import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { showCurrency } from '../../utils';

function formatShort(monto) {
	return `${Math.round(monto / 1000)}k`;
}

function formatFull(monto, currency) {
	return `${showCurrency(currency) || ''} ${Math.round(monto).toLocaleString('es-UY')}`.trim();
}

/**
 * Monthly bar row — 150px tall, bottom-aligned, one column per month.
 * `moduleClasses.tile` supplies the bar fill so it always matches the
 * selected type's card color. The peak month renders at full opacity;
 * every other month sits at 0.45.
 */
function MonthlyBars({ months, currency, maxMonto, peakMes, moduleClasses }) {
	return (
		<div>
			<div className='tw:flex tw:items-end tw:gap-2.5 tw:h-[150px] tw:px-6 tw:pt-5'>
				{months.map((month) => {
					const monto = month[currency].monto;
					const isPeak = month.mes === peakMes;
					return (
						<div key={month.mes} className='tw:flex tw:flex-1 tw:flex-col tw:items-center tw:h-full tw:justify-end tw:gap-1.5'>
							<span className='tw:font-mono tw:text-[10.5px] tw:text-ink-2'>{formatShort(monto)}</span>
							<div
								title={formatFull(monto, currency === 'usd' ? 'USD' : 'UYU')}
								className={classnames(
									'tw:w-full tw:max-w-[46px] tw:rounded-t-[5px] tw:transition-[height] tw:duration-300 tw:motion-reduce:transition-none',
									moduleClasses.tile,
								)}
								style={{
									height: `${Math.max(4, (monto / maxMonto) * 100)}%`,
									minHeight: '4px',
									opacity: isPeak ? 1 : 0.45,
								}}
							/>
						</div>
					);
				})}
			</div>
			<div className='tw:flex tw:gap-2.5 tw:px-6 tw:pb-2 tw:pt-2.5'>
				{months.map((month) => (
					<span key={month.mes} className='tw:flex-1 tw:text-center tw:text-[11px] tw:font-medium tw:text-ink-3'>
						{month.label}
					</span>
				))}
			</div>
		</div>
	);
}

MonthlyBars.propTypes = {
	months: PropTypes.array.isRequired,
	currency: PropTypes.oneOf(['uyu', 'usd']).isRequired,
	maxMonto: PropTypes.number.isRequired,
	peakMes: PropTypes.string,
	moduleClasses: PropTypes.shape({ tile: PropTypes.string.isRequired }).isRequired,
};

export default MonthlyBars;
